import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api';

function isFormDataBody(data) {
  if (!data || typeof data !== 'object') return false;
  if (typeof FormData !== 'undefined' && data instanceof FormData) return true;
  return data[Symbol.toStringTag] === 'FormData' && typeof data.append === 'function';
}

function unsetContentType(headers) {
  if (!headers) return;
  // Only this request's headers — do not walk common/post defaults.
  if (typeof headers.delete === 'function') {
    headers.delete('Content-Type');
    headers.delete('content-type');
  }
  if (typeof headers.set === 'function') {
    headers.set('Content-Type', false);
  }
}

const instance = axios.create({
  baseURL: API_BASE_URL,
  // Auth is Bearer in sessionStorage. Sending Chrome's cookie jar on every
  // cross-origin call can make Flask/Werkzeug reject the request with 400.
  withCredentials: false,
});

instance.interceptors.request.use(
  (config) => {
    if (!config.headers) {
      config.headers = {};
    }

    let user = {};
    try {
      user = JSON.parse(sessionStorage.getItem('user') || '{}');
    } catch {
      user = {};
    }
    const token = user.token;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    if (isFormDataBody(config.data)) {
      // Chrome will not add the multipart boundary if Content-Type is already
      // set to "multipart/form-data". Let the browser set the full header.
      unsetContentType(config.headers);
    } else if (
      config.data
      && typeof config.data === 'object'
      && !config.headers['Content-Type']
      && !config.headers['content-type']
    ) {
      config.headers['Content-Type'] = 'application/json';
    }

    return config;
  },
  (error) => Promise.reject(error)
);

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const url = error.config?.url || '';
      const message = String(error.response?.data?.error || '');
      const poolBusy = /server is busy|token validation failed|queuepool|timed out/i.test(message);
      if (!poolBusy && !url.includes('/auth/login')) {
        sessionStorage.removeItem('user');
        window.location.href = '/login';
      }
    }

    if (error.response?.status === 403) {
      console.error('Access denied:', error.response.data?.error);
    }

    return Promise.reject(error);
  }
);

export default instance;
